export default __webpack_public_path__ + "static/media/yen-1-object.b79a9000.jpg";